import RoutePath from 'router/path';

import { AccountAccessLevel, AccountType } from 'types/account';

import { PartnerFeatures, canManageAccount } from './features';

export const shouldRegisterPartnerAccountSettings = (accountType: AccountType, accessLevel: AccountAccessLevel): boolean =>
  accountType === AccountType.Pwc && canManageAccount(accessLevel);

export const getPartnerAccountSettingsChildPaths = (features: PartnerFeatures): string[] => {
  const paths = [RoutePath.Pwc.Accounts.General, RoutePath.Pwc.AccountSettings.Users, RoutePath.Pwc.AccountSettings.APIKeys];

  if (features.pwc) {
    paths.push(RoutePath.Pwc.AccountSettings.Settlement, RoutePath.Pwc.AccountSettings.RefundAccount);
  }

  if (features.cryptoPayout) {
    paths.push(RoutePath.Pwc.AccountSettings.PayoutReserve);
  }

  return paths;
};
